export default __webpack_public_path__ + "static/beachhouseextra-5fb30459aeb678675e5f77d33811257a.jpg";